import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  Users: {
    position: 'relative',
    '&__add': {
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-end',
      margin: '0 auto',
      padding: theme.spacing(6, 0),
      width: '100%',
      '& > button': {
        boxShadow: '0 6px 10px -4px rgb(0 0 0 / 15%) !important',
      },
    },
  },
}));
